export function onBooleanChange(field, value) {
  const { state } = this
  const { model } = state

  model[field] = value

  this.setState(state)
}



// WEBPACK FOOTER //
// ./src/models/helpers/onBooleanChange.js